import { useState } from 'react';

const faqItems = [
  {
    id: 1,
    question: '苹果视频真的完全免费吗？需要注册登录吗？',
    answer: '是的，苹果视频完全免费，无需注册、无需登录、无需任何付费，打开网站即可免费观看全部高清电影电视剧资源。我们通过广告合作维持运营，为用户提供持续免费的观影服务。',
  },
  {
    id: 2,
    question: '苹果视频支持哪些设备观看？画质怎么样？',
    answer: '苹果视频支持电脑、平板、手机等所有主流设备在线观看，无需下载任何播放器或App。我们提供全高清1080P画质播放，部分影片支持4K超清画质，智能CDN加速确保零缓冲流畅播放。',
  },
  {
    id: 3,
    question: '影片资源多久更新一次？能看到最新上映的电影吗？',
    answer: '苹果视频内容团队每日持续更新，平均每天新增50+部影视资源。热门院线电影下映后会尽快上线高清版本，热播电视剧同步各大平台更新节奏，让你第一时间看到最新内容。',
  },
  {
    id: 4,
    question: '西瓜视频免费和免费视频网站91的内容都能在苹果视频看到吗？',
    answer: '苹果视频整合了包括西瓜视频免费、免费视频网站91等热门影视频道的海量资源，你可以在这里一站式浏览多个平台的精彩内容。我们持续扩充片库，努力覆盖更多优质影视资源频道。',
  },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            关于苹果视频的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFaq(item.id)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 transition-transform duration-300 ${
                  openId === item.id ? 'bg-primary-100 rotate-180' : 'bg-secondary-100'
                }`}>
                  <i className={`text-sm ${openId === item.id ? 'ri-subtract-line text-primary-500' : 'ri-add-line text-secondary-500'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === item.id ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}